import { gameLogger } from "../logging/gameLogger.ts";
import type { AnalyticsPort } from "../ports.ts";
import { getGameplaySessionContext } from "./gameplaySessionContext.ts";

/** DEV console sink for gameplay analytics events (no PostHog). */
export function createLoggingAnalyticsPort(): AnalyticsPort {
  return {
    emit(eventName, properties, context) {
      const session = getGameplaySessionContext();
      gameLogger.info(
        "session",
        eventName,
        session ? { sessionId: session.sessionId } : undefined,
        {
          ...(properties ?? {}),
          ...(context ?? {}),
        },
      );
    },
  };
}
